<template>
  <hm-content title="">
    <div class="flex flex-between item-center mb20">
      <div class="flex">
        <el-button type="primary" size="small" @click="AddNewCode"
          >创建活码</el-button
        >
        <div class="config-btn" @click="handlePageConfig"
          ><img src="https://redpackagecdn.hemiao100.com/static/setup.png" alt="">页面配置</div
        >
      </div>
      <div class="table-panel flex flex-end">
        <el-select
          v-model="searchCondition.type"
          placeholder="请选择活码类型"
          class="mr10"
          size="small"
          filterable
          clearable
        >
          <el-option
            :label="item.label"
            :value="item.value"
            v-for="(item, index) in typeList"
            :key="index"
          >
          </el-option>
        </el-select>
        <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.enabledState"
          placeholder="请选择活动状态"
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-button class="mr10" size="small" type="primary" @click="queryList"
          >查询</el-button
        >
        <!-- <el-button
          class="mr10"
          size="small"
          type="primary"
          @click="output"
          :loading="isOutputing"
          >导出
        </el-button> -->
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="gameTitle"
          label="活码名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="gameType"
          label="活码类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.gameType === 'qr_code_shop'">门店活码</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalShowNum"
          label="访问次数"
        >
          <template slot-scope="scope">
            <div>今日:{{ scope.row.dailyShowNum || 0 }}</div>
            <div>累计:{{ scope.row.totalShowNum || 0 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="state"
          label="状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.enabledState === 'yes'" class="success"
              >正常</span
            >
            <span v-if="scope.row.enabledState === 'no'" class="gray"
              >已下线</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="productQrcode(scope.row)"
                >获取二维码</el-button
              >
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <button
                v-if="
                  scope.row.updateMode === 'yes' &&
                  scope.row.enabledState === 'no'
                "
                class="pointer mr10 no-bg blue"
                @click="shangxian(scope.row)"
              >
                上线
              </button>
              <button
                class="pointer mr10 no-bg danger"
                @click="xiaxian(scope.row)"
                v-if="scope.row.enabledState !== 'no'"
              >
                下线
              </button>
              <!-- <el-button
                type="text"
                class="blue"
                size="small"
                @click="remove(scope.row)"
                >删除</el-button
              > -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
        title="请用微信扫一扫"
        :visible.sync="qrcodeDialogVisible"
        :modal="false"
        width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width:100%" :src="activityCode" alt="二维码" />
      </div>
      <div class="mt10 flex flex-center">
        <el-button @click='copyToClipboard(codePath)' type='primary' size='small'>复制链接</el-button>
      </div>
    </el-dialog>
    </div>
      <el-dialog
        title='页面配置'
        :visible.sync='configVisible'
        width='780px'
        :close-on-click-modal='false'
        :close-on-press-escape='false'
        destroy-on-close
        custom-class='common-dialog'
      >
      <el-form :model="configForm" label-width="80px">
        <el-form-item label="订单详情">
          <el-switch
            v-model="configForm.order.open"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭">
          </el-switch>
          <div class="flex mb20">
            <div class="label">活码名称</div>
            <div class="content">
              <el-select v-model="configForm.order.name">
                <el-option v-for="item in optionlist" :key="item.gameId" :label="item.gameName" :value="item.gameId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="flex">
            <div class="label required">背景图</div>
            <div class="content">
              <div class="desc">图片尺寸建议690x260（最多上传一张） </div>
              <div class="flex">
                <div class="left-img">
                  <img :src="configForm.order.background" alt="">
                  <el-button type="primary" @click="handleChangeBg('order')">更换</el-button>
                </div>
                <div class="right-img">
                  <div class="tag">效果图</div>
                  <img :src="configForm.order.background" alt="">
                  <div class="qrcode-wrap">
                    <img src="https://redpackagecdn.hemiao100.com/static/page-config-qrcode.png" alt="" class="qrcode">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="支付成功">
          <el-switch
            v-model="configForm.pay.open"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开启"
            inactive-text="关闭">
          </el-switch>
          <div class="flex mb20">
            <div class="label">活码名称</div>
            <div class="content">
              <el-select v-model="configForm.pay.name">
                <el-option v-for="item in optionlist" :key="item.gameId" :label="item.gameName" :value="item.gameId"></el-option>
              </el-select>
            </div>
          </div>
          <div class="flex">
            <div class="label required">背景图</div>
            <div class="content">
              <div class="desc">图片尺寸建议690x260（最多上传一张） </div>
              <div class="flex">
                <div class="left-img">
                  <img :src="configForm.pay.background" alt="">
                  <el-button type="primary" @click="handleChangeBg('pay')">更换</el-button>
                </div>
                <div class="right-img">
                  <div class="tag">效果图</div>
                  <img :src="configForm.pay.background" alt="">
                  <div class="qrcode-wrap">
                    <img src="https://redpackagecdn.hemiao100.com/static/page-config-qrcode.png" alt="" class="qrcode">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
        <template slot='footer'>
          <el-button @click='handleAddPageConfig' type='primary' size='small'>确定</el-button>
        </template>
      </el-dialog>

      <hm-upload
        :hmUploadVisible="hmUploadVisible"
        fileDir="decoration"
        @cancleUpload="cancleUpload"
        @hmUploadSuccess="hmUploadSuccess"
      ></hm-upload>
  </hm-content>
</template>
<script>
import { getLoginUser, getUserName } from "@/utils/auth";
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import moment from "moment";
import HmUpload from "@/components/HmUpload";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {
    HmUpload,
  },
  data() {
    return {
      hmUploadVisible: false,
      configVisible: false,
      initBackground:
        "https://redpackagecdn.hemiao100.com/static/background.png",
      configForm: {
        order: {
          open: false,
          name: "",
          background: "",
        },
        pay: {
          open: false,
          name: "",
          background: "",
        },
      },
      typeList: [
        {
          label: "门店活码",
          value: "qr_code_shop",
        },
      ],
      stateList: [
        {
          label: "正常",
          value: "1",
        },
        {
          label: "已下线",
          value: "2",
        },
      ],
      searchCondition: {
        type: "",
        enabledState: "",
      },
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keyword: "",
      gameType: "qr_code_shop",
      dateFlag: "0",
      qrcodeDialogVisible: false,
      activityCode: "",
      optionlist: [],
      bgKey: "",
      detailInfo: null,
      codePath: "",
    };
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryAllList();
  },
  methods: {
    init() {
      this.$store
        .dispatch("getModelByParamCode", {
          paramCode: "intelligent_code_page_config",
        })
        .then((res) => {
          console.log("---res---", res);
          this.detailInfo = res.result;
          if (!res.result) {
            this.configForm.order.background = this.initBackground;
            this.configForm.pay.background = this.initBackground;
          } else {
            this.configForm = JSON.parse(res.result.optionValues)
          }
          this.configVisible = true;
        });
    },
    /**
     * @desc 页面配置保存
     */
    handleAddPageConfig() {
      if (this.configForm.order.open && !this.configForm.order.background) {
        return this.$message.warning("请上传背景图！");
      }

      if (this.configForm.order.open && !this.configForm.order.background) {
        return this.$message.warning("请上传背景图！");
      }

      if (!this.detailInfo) {
        // 新增
        this.$store
          .dispatch("addStoreSystemParamInfo", {
            paramCode: "intelligent_code_page_config",
            paramValue: true,
            optionValues: JSON.stringify(this.configForm),
            configType: "store",
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("配置成功！");
              this.configVisible = false;
            }
          });
      } else {
        this.$store
          .dispatch("editStoreSystemParamInfo", {
            paramCode: "intelligent_code_page_config",
            paramValue: true,
            optionValues: JSON.stringify(this.configForm),
            id: this.detailInfo.id,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message.success("配置成功！");
              this.configVisible = false;
            }
          });
      }
    },
    handleChangeBg(key) {
      this.bgKey = key;
      this.hmUploadVisible = true;
    },
    hmUploadSuccess(url) {
      this.configForm[this.bgKey]["background"] = url;
      this.hmUploadVisible = false;
    },
    cancleUpload() {
      this.hmUploadVisible = false;
    },
    handleRemove() {
      this.configForm[this.bgKey]["background"] = "";
    },
    handlePageConfig() {
      this.init()
    },
    AddNewCode() {
      this.$router.push({
        name: "IntelligentCodeType",
      });
    },
    async queryAllList() {
      const { result } = await this.$store.dispatch("queryMyActivityList", {
        pageNo: 1,
        pageSize: 9999,
        splitType: "qr_code",
      });
      if (result) {
        this.optionlist = result.pageList.records;
        console.log("---optionlist---", this.optionlist);
      }
    },
    async queryList() {
      const { result } = await this.$store.dispatch("queryMyActivityList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        dateFlag: this.dateFlag,
        enabledState: this.searchCondition.enabledState,
        gameType: this.gameType,
        keyWords: this.keyword,
        splitType: "qr_code",
      });
      if (result) {
        this.list = result.pageList.records;
        this.total = result.pageList.total;
        console.log("result:", result);
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    edit(row) {
      this.$router.push({
        name: "IntelligentCodeDetail",
        query: {
          gameType: row.gameType,
          gameId: row.gameId,
        },
      });
    },
    remove() {},
    xiaxian(row) {
      this.$store
        .dispatch("updateEnabled", {
          gameId: row.gameId,
          enabledState: "no",
        })
        .then((res) => {
          if (res.code === "0") {
            this.queryList();
          }
        });
    },
    shangxian(row) {
      this.$store
        .dispatch("updateEnabled", {
          gameId: row.gameId,
          enabledState: "yes",
        })
        .then((res) => {
          if (res.code === "0") {
            this.queryList();
          }
        });
    },
    async productQrcode(row) {
      let path = "";
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `activity/IntelligentCode/IntelligentCode?gameId=${row.gameId}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "应用中心-智能活码",
        shareFrom: "bg",
      };
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      path = `activity/IntelligentCode/IntelligentCode?saveUUID=${url.result}`;
      this.codePath = path
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path,
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText('/'+text);
        this.$message.success("复制成功");
      } catch (err) {
          this.fallbackCopy('/' + text);
      }
    },
    // 备用复制方法-用户浏览器不支持clipboard.writeText()
    fallbackCopy(text) {
      const input = document.createElement('input');
      input.style.position = 'fixed';
      input.style.opacity = 0;
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      console.log('使用备用方法复制文本');
      this.$message.success("复制成功");
    }
  },
};
</script>
<style lang="scss" scoped>
.flex {
  .label {
    font-family: PingFang TC, PingFang TC;
    font-weight: 400;
    font-size: 14px;
    color: #222222;
    margin-right: 20px;
  }
  .required {
    &::before {
      content: "*";
      color: rgb(255, 73, 73);
    }
  }
  .content {
    .left-img,
    .right-img {
      width: 280px;
      height: 105px;
      position: relative;
      border-radius: 5px 5px 5px 5px;
      overflow: hidden;
      img {
        width: 280px;
        height: 105px;
      }
      .el-button {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 51px;
        height: 24px;
        padding: 0;
        z-index: 100;
      }
    }
    .left-img {
      margin-right: 20px;
      &::before {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background: rgba(0, 0, 0, 0.3);
      }
    }
    .right-img {
      .tag {
        position: absolute;
        left: 0;
        top: 0;
        width: 52px;
        height: 18px;
        text-align: center;
        line-height: 18px;
        background: #e50065;
        border-radius: 4px 0px 4px 0px;
      }
      .qrcode-wrap {
        width: 81px;
        height: 81px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ffffff;
        box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.24);
        border-radius: 13px 13px 13px 13px;
        position: absolute;
        top: 12px;
        right: 19px;
        img {
          width: 77px;
          height: 77px;
        }
      }
    }
  }
}
.config-btn {
  display: flex;
  align-items: center;
  margin-left: 20px;
  height: 34px;
  cursor: pointer;
  img {
    margin-right: 5px;
    width: 20px;
    height: 20px;
  }
}
</style>
